const lowercaseTitleWords = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'from',
  'in',
  'into',
  'nor',
  'of',
  'on',
  'or',
  'over',
  'per',
  'the',
  'to',
  'up',
  'via',
  'with',
])

export function toTitleCase(s: string): string {
  // Replace multiple whitespaces with single, and split
  const split = s.split(/\s+/g)
  const upper = split
    .map((s, i) => {
      if (!s) return s
      if (/^\(.+\)$/.test(s)) return s
      const lowerWord = s.toLowerCase()
      if (i > 0 && i < split.length - 1 && lowercaseTitleWords.has(lowerWord)) {
        return lowerWord
      }
      if ((lowerWord.startsWith("o'") || lowerWord.startsWith('o’')) && lowerWord.length > 2) {
        return lowerWord.slice(0, 3).toUpperCase() + lowerWord.slice(3)
      }
      if ((lowerWord.startsWith("d'") || lowerWord.startsWith('d’')) && lowerWord.length > 2) {
        return lowerWord.slice(0, 3).toUpperCase() + lowerWord.slice(3)
      }
      if ((lowerWord.startsWith("mc'") || lowerWord.startsWith('mc’')) && lowerWord.length > 2) {
        return 'Mc' + lowerWord.slice(2, 4).toUpperCase() + lowerWord.slice(4)
      }
      if (lowerWord.startsWith('mc') && lowerWord.length > 2) {
        return 'Mc' + lowerWord.slice(2, 3).toUpperCase() + lowerWord.slice(3)
      }
      return s[0].toUpperCase() + lowerWord.slice(1)
    })
    .join(' ')
  return upper.trim()
}

export function capitalize(s: string) {
  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`
}
